import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  rounded?: boolean;
  type?:
    | 'General'
    | 'Limited'
    | 'Discount'
    | 'Bestseller'
    | 'Generic-Beige'
    | 'Red-Sale'
    | 'Clever'
    | 'Premium'
    | 'Pink'
    | 'Neutral'
    | 'Vet'
    | string;
  size?: 'sm' | 'inherit';
}

/**
 * Badge component
 */
const Badge: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  rounded,
  type,
  size = 'sm',
}) => {
  let colorClassName = '';

  switch (type) {
    case 'Red-Sale':
    case 'Discount':
      colorClassName = 'bg-badge-discount font-medium text-text-dark-bg-contrast-white';
      break;
    case 'Bestseller':
      colorClassName = 'bg-badge-bestseller text-primary-main';
      break;
    // TODO: General/Generic-Beige and Default really close to each other, should we keep only recent version?
    case 'General':
    case 'Generic-Beige':
      colorClassName = 'bg-badge-generic text-text-primary';
      break;
    case 'Neutral':
      colorClassName = 'bg-background-default text-text-light-bg-primary';
      break;
    case 'Clever':
      colorClassName = 'bg-background-clever-plan text-other-white';
      break;
    case 'Premium':
      colorClassName = 'bg-background-premium-plan text-other-white';
      break;
    case 'Pink':
      colorClassName = 'bg-secondary-main text-other-white';
      break;
    case 'Vet':
      colorClassName = 'bg-turquoise-300 text-text-light-bg-primary';
      break;
    default:
      colorClassName = 'bg-badge-new text-primary-main';
      break;
  }

  return (
    <div
      data-test="badge"
      className={twMerge(
        'h-auto shrink-0 items-center justify-center px-1.5 py-0.5 text-center',
        colorClassName,
        rounded ? 'rounded-full' : 'rounded',
        className,
        size === 'sm' ? 'text-sm' : ''
      )}
    >
      <span data-test="ribbon" className="block">
        {children}
      </span>
    </div>
  );
};
export default Badge;
